import { useEffect } from "react"

import { createApp } from "@shopify/app-bridge"
import { getSessionToken } from '@shopify/app-bridge-utils';
import { authenticatedFetch } from "@shopify/app-bridge/utilities";
import { Redirect } from "@shopify/app-bridge/actions";


import './App.css';

const app = createApp({
  apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
  host: new URLSearchParams(window.location.search)?.get("host"),
  forceRedirect: true,
});

const fetchAuthenticated = authenticatedFetch(app);

function App() {

  const handleAuth = async () => {

    await getSessionToken(app)

    return
  }

  const handleAppInstallation = async () => {

    const shopDomain = new URLSearchParams(window.location?.search)?.get("shop")

    const response = await fetchAuthenticated(`${process.env.REACT_APP_TMR_APP_SERVICE_URL}/shopify/get-auth-info?shop=${shopDomain}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response?.ok) {
      const data = await response.json();

      if (Boolean(data?.isAuthorized) === false) {

        const authId = `shopify-${new Date().getTime().toString()}`
        const defaultTmrOrigin = "gs"
        const shopName = shopDomain?.replace(".myshopify.com", "")

        const authorizationUrl = `${process.env.REACT_APP_TMR_APP_SERVICE_URL}/connect/shopify?authId=${authId}&origin=${defaultTmrOrigin}&shopifyAppType=publicApp&subdomain=${shopName}`

        const redirect = Redirect.create(app);

        redirect.dispatch(Redirect.Action.REMOTE, authorizationUrl);

      }
    }

    return
  }

  useEffect(() => {

    // handleAppInstallation()
    handleAuth()

  }, [])


  return (
    <div className="App">
      <div className="container">
        <div className="content">

          <div className="header">

            <div className="row-one">
              <h2>Two Minute Reports</h2>
              <a href="https://twominutereports.com/support-ticket" target="_blank">Contact support</a>
            </div>

            <div className="row-two">
              <p>Turn Shopify Data into Insights with Google Sheets & Looker Studio</p>
            </div>
          </div>
          <div className="destinations">

            <div className="destination-card">

              <div className="destination-logo-container destination-logo-container-gs">
                <img src="https://assets.gox.ai/tmr/assets/icons/google-sheets-icon.svg" alt="" className="destination-logo" />
              </div>

              <div className="destination-body">
                <img src="https://assets.gox.ai/tmr/assets/logo/tmr_horizontal_black_without_padding.svg" alt="" className="two-minute-reports-full-logo" />
                <p className="destination-text"><span className="destination-for-text">for</span> <span
                  className="destination-label">Google Sheets</span></p>
                <br />
                <a className="destination-signup-btn"
                  href="https://docs.google.com/spreadsheets/d/1w2Rwo0LJdtz1_y6B2y1cO5yb0EJYW37mRWtSylocaVU/template/preview"
                  target="_blank">Sign up</a>
              </div>

            </div>

            <div className="destination-card">
              <div className="destination-logo-container destination-logo-container-gds">
                <img src="https://assets.gox.ai/tmr/assets/icons/looker-studio-icon.svg" alt="" className="destination-logo" />
              </div>

              <div className="destination-body">
                <img src="https://assets.gox.ai/tmr/assets/logo/tmr_horizontal_black_without_padding.svg" alt="" className="two-minute-reports-full-logo" />
                <p className="destination-text"><span className="destination-for-text">for</span> <span
                  className="destination-label">Looker Studio</span></p>
                <br />
                <a className="destination-signup-btn" href="https://hub.twominutereports.com"
                  target="_blank">Sign up</a>
              </div>
            </div>

          </div>

          <hr className="footer-separator" />

          <div className="footer">
            <p>Signup to connect Two Minute Reports account to your Shopify store</p>
            <a href="https://twominutereports.com/signup" target="_blank">Try for Free</a>
          </div>

        </div>
      </div>
    </div>
  );
}

export default App;
